(function ($) {
  $(document).ready(function () {
    var section = $('.cta.animate');
    if (section.length > 0) {
      function isSectionInCenter() {
        var viewportTop = $(window).scrollTop() - 300;
        var viewportBottom = viewportTop + $(window).height();
        var viewportCenter = (viewportTop + viewportBottom) / 2;
        var sectionTop = section.offset().top;
        var sectionBottom = sectionTop + section.height();
        var sectionCenter = (sectionTop + sectionBottom) / 2;
        return Math.abs(viewportCenter - sectionCenter) < $(window).height() / 2;
      }

      $(window).on('load scroll', function () {
        if (isSectionInCenter()) {
          section.addClass("cta-animation-active");
        } else {
          section.removeClass("cta-animation-active");
        }
      });
    }
  });
})(jQuery);
